import { render, staticRenderFns } from "./CustomerComponent.vue?vue&type=template&id=c7a308fe"
import script from "./CustomerComponent.vue?vue&type=script&lang=js"
export * from "./CustomerComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerComponent.vue?vue&type=style&index=0&id=c7a308fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports